import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { CashDividend } from '../_models/cash-dividend';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {

  public dividendsTotal = new Subject<number>();
  public interestTotal = new Subject<number>();
  public managementFeesTotal = new Subject<number>();
  public otherFeesTotal = new Subject<number>();
  public executionCostsTotal = new Subject<number>();

  public cashDividends = new Subject<CashDividend[]>();
  public fxTranslation = new Subject<number>();

  public finAdvisorFeesInBase = new Subject<number>();
  public percentOfEquityFeesInBase = new Subject<number>();

  public rootScope: BehaviorSubject<any> = new BehaviorSubject(null);
  public user: BehaviorSubject<any> = new BehaviorSubject(null);
  public whiteBranding: BehaviorSubject<any> = new BehaviorSubject(null);

  // NET value (allCashDividendsInBase + allWithholdTaxInBase)
  public sendDividendsTotal(dividendsTotal: number) {
    this.dividendsTotal.next(dividendsTotal);
  }

  // Paid & Received value excluding accrued (interestPaidInBase + interestReceivedInBase)
  public sendInterestTotal(interestTotal: number) {
    this.interestTotal.next(interestTotal);
  }

  // The total value of management fees (allManagementFeesInBase)
  public sendManagementFeesTotal(managementFeesTotal: number) {
    this.managementFeesTotal.next(managementFeesTotal);
  }

  // The total value of other fees (allOtherFeesInBase)
  public sendOtherFeesTotal(otherFeesTotal: number) {
    this.otherFeesTotal.next(otherFeesTotal);
  }

  // The total value of execution costs (totalCommissionsInBase + totalTaxesInBase)
  public sendExecutionCostsTotal(executionCostsTotal: number) {
    this.executionCostsTotal.next(executionCostsTotal);
  }

  // All the dividends taken into account the withheld tax
  public sendCashDividends(cashDividends: CashDividend[]) {
    this.cashDividends.next(cashDividends);
  }

  // fxTranslation for Belgian Yearly Forms
  public sendFXTranslation(fxTranslation: number) {
    this.fxTranslation.next(fxTranslation);
  }

  // Tresor Capital Advisor Fees
  public sendFinAdvisorFeesInBase(finAdvisorFeesInBase: number) {
    this.finAdvisorFeesInBase.next(finAdvisorFeesInBase)
  }

  // LYNX All-In Fee
  public sendPercentOfEquityFeesInBase(percentOfEquityFeesInBase: number) {
    this.percentOfEquityFeesInBase.next(percentOfEquityFeesInBase)
  }

  public resetValues() {
    this.dividendsTotal.next(0);
    this.interestTotal.next(0);
    this.managementFeesTotal.next(0);
    this.otherFeesTotal.next(0);
    this.executionCostsTotal.next(0);
    this.cashDividends.next([]);
    this.fxTranslation.next(0);
  }

  public setRootScope(rootScope: any) {
    this.rootScope.next(rootScope);
    this.user.next(rootScope.$$childHead.user);

    // Keep re-checking if white branding is not yet set
    if (!Object.keys(rootScope.$$childHead.$parent.wb).length) {
      let wbInterval = setInterval(() => {
        if (!!Object.keys(rootScope.$$childHead.$parent.wb).length) {
          this.whiteBranding.next(rootScope.$$childHead.$parent.wb)
          clearInterval(wbInterval);
        }
      }, 500);
    }
  }

  public isPPRAdmin() {
    return this.user.value.authorities.map(a => a.authority).includes('ROLE_PPR_ADMIN');
  }

  public destroy() {
    this.dividendsTotal = new Subject<number>();
    this.interestTotal = new Subject<number>();
    this.managementFeesTotal = new Subject<number>();
    this.otherFeesTotal = new Subject<number>();
    this.executionCostsTotal = new Subject<number>();
    this.cashDividends = new Subject<CashDividend[]>();
    this.fxTranslation = new Subject<number>();
  }
}
